module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt":{"notFound":"{code}! Página não encontrada","unauthorized":"{code}! Você não tem permissão para acessar esta pagina","error":"Ocorreu um erro","logout":"Sair"},"en":{"notFound":"{code}! Page not found","unauthorized":"{code}! You do not have permission to access this page","error":"An error occurred","logout":"Log out"}}')
  delete Component.options._Ctor
}
